import { render, staticRenderFns } from "./filter-tab.component.vue?vue&type=template&id=55d43284"
import script from "./filter-tab.component.vue?vue&type=script&lang=js"
export * from "./filter-tab.component.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports